export interface TourStep {
  /** CSS selektor celu kroku (np. `[data-tour="employee-first-name"]`). Brak = krok wyśrodkowany. */
  selector?: string;
  titleKey: string;
  bodyKey: string;
  /** Czy ten krok symuluje zapis (pokaż „to symulacja, nic nie zapisano"). */
  simulatesSave?: boolean;
}

export interface TourDefinition {
  id: string;
  titleKey: string;
  descriptionKey: string;
  icon: string;
  /** Trasa, na której działa samouczek (ścieżka bez query). */
  route: string;
  /** Klucz grupy modułu na stronie Samouczek. */
  group: string;
  steps: TourStep[];
  /** Czy oferowany jest wariant „symulacja bez zapisu". */
  sandbox?: boolean;
}

/**
 * Rejestr samouczków panelu Kadry. Selektory kroków celują w atrybuty `data-tour="..."`
 * obecne na docelowych ekranach. Treść kroków tłumaczona kluczami transloco.
 */
export const TOUR_REGISTRY: TourDefinition[] = [
  {
    id: 'dashboard',
    titleKey: 'tour.dashboard.title',
    descriptionKey: 'tour.dashboard.description',
    icon: 'speed',
    route: '/',
    group: 'overview',
    steps: [
      { titleKey: 'tour.dashboard.steps.intro.title', bodyKey: 'tour.dashboard.steps.intro.body' },
      { selector: '[data-tour="dashboard-title"]', titleKey: 'tour.dashboard.steps.header.title', bodyKey: 'tour.dashboard.steps.header.body' },
      { selector: '[data-tour="dashboard-stats"]', titleKey: 'tour.dashboard.steps.stats.title', bodyKey: 'tour.dashboard.steps.stats.body' },
    ],
  },
  {
    id: 'employees',
    titleKey: 'tour.employees.title',
    descriptionKey: 'tour.employees.description',
    icon: 'pi pi-users',
    route: '/hr',
    group: 'hr',
    steps: [
      { titleKey: 'tour.employees.steps.intro.title', bodyKey: 'tour.employees.steps.intro.body' },
      { selector: '[data-tour="employees-new"]', titleKey: 'tour.employees.steps.new.title', bodyKey: 'tour.employees.steps.new.body' },
      { selector: '[data-tour="employees-table"]', titleKey: 'tour.employees.steps.table.title', bodyKey: 'tour.employees.steps.table.body' },
    ],
  },
  {
    id: 'employee',
    titleKey: 'tour.employee.title',
    descriptionKey: 'tour.employee.description',
    icon: 'pi pi-user-plus',
    route: '/hr/employees/create',
    group: 'hr',
    sandbox: true,
    steps: [
      { titleKey: 'tour.employee.steps.intro.title', bodyKey: 'tour.employee.steps.intro.body' },
      { selector: '[data-tour="employee-first-name"]', titleKey: 'tour.employee.steps.firstName.title', bodyKey: 'tour.employee.steps.firstName.body' },
      { selector: '[data-tour="employee-last-name"]', titleKey: 'tour.employee.steps.lastName.title', bodyKey: 'tour.employee.steps.lastName.body' },
      { selector: '[data-tour="employee-save"]', titleKey: 'tour.employee.steps.save.title', bodyKey: 'tour.employee.steps.save.body', simulatesSave: true },
    ],
  },
  {
    id: 'payroll',
    titleKey: 'tour.payroll.title',
    descriptionKey: 'tour.payroll.description',
    icon: 'pi pi-wallet',
    route: '/hr/payroll',
    group: 'hr',
    steps: [
      { titleKey: 'tour.payroll.steps.intro.title', bodyKey: 'tour.payroll.steps.intro.body' },
      { selector: '[data-tour="payroll-period"]', titleKey: 'tour.payroll.steps.period.title', bodyKey: 'tour.payroll.steps.period.body' },
      { selector: '[data-tour="payroll-actions"]', titleKey: 'tour.payroll.steps.actions.title', bodyKey: 'tour.payroll.steps.actions.body' },
      { selector: '[data-tour="payroll-table"]', titleKey: 'tour.payroll.steps.table.title', bodyKey: 'tour.payroll.steps.table.body' },
    ],
  },
  {
    id: 'approvals',
    titleKey: 'tour.approvals.title',
    descriptionKey: 'tour.approvals.description',
    icon: 'pi pi-check-square',
    route: '/hr/approvals',
    group: 'hr',
    steps: [
      { titleKey: 'tour.approvals.steps.intro.title', bodyKey: 'tour.approvals.steps.intro.body' },
      { selector: '[data-tour="approvals-absences"]', titleKey: 'tour.approvals.steps.absences.title', bodyKey: 'tour.approvals.steps.absences.body' },
      { selector: '[data-tour="approvals-trips"]', titleKey: 'tour.approvals.steps.trips.title', bodyKey: 'tour.approvals.steps.trips.body' },
    ],
  },
];
